import React, { useContext } from 'react';
import { Alert, Box } from '@mui/material';
import { LanguageContext } from '../../../../../../libs/Context';

const ApprovalNotice = ({ isEditMode }: { isEditMode?: boolean }) =>
{
	const { language } = useContext(LanguageContext);

	const getMessage = (): string =>
	{
		if (isEditMode)
		{
			return language?.feedUpdateApprovalNotice || 'This update will be sent for admin approval before it is posted.';
		}

		return language?.feedApprovalNotice || 'This feed will be sent for admin approval before it is posted.';
	};

	return (
		<Box mb={2}>
			<Alert severity='info'>
				{getMessage()}
			</Alert>
		</Box>
	);
};

export default ApprovalNotice;
